const API_URL = process.env.REACT_APP_API_URL;

export async function getCarriers() {
  const response = await fetch(`${API_URL}/transporteur`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Erreur lors de la récupération des transporteurs");
  return response.json();
}


// GET all transports for a ticket
export async function getTicketTransports(ticketId) {
  const response = await fetch(`${API_URL}/ticket/${ticketId}/transports`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Erreur lors de la récupération des transports");
  return response.json();
}

// POST create a transport
// DTO expects: { transport: { numero, prix, transporteur } }
// API returns: { id, tracking_number, price }
export async function createTicketTransport(ticketId, transportData) {
  const response = await fetch(`${API_URL}/ticket/${ticketId}/transport`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      transport: {
        numero:      transportData.tracking_number,
        prix:        transportData.price,
        transporteur: transportData.carrier_id,
      },
    }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || "Erreur lors de la création du transport");
  }
  return response.json();
}

// PUT update a transport
export async function updateTicketTransport(ticketId, transportationId, transportData) {
  const response = await fetch(`${API_URL}/ticket/${ticketId}/transport/${transportationId}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      transport: {
        numero:      transportData.tracking_number,
        prix:        transportData.price,
        transporteur: transportData.carrier_id,
      },
    }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || "Erreur lors de la modification du transport");
  }
  return response.json();
}

// DELETE a transport
export async function deleteTicketTransport(ticketId, transportationId) {
  const response = await fetch(`${API_URL}/ticket/${ticketId}/transport/${transportationId}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || "Erreur lors de la suppression du transport");
  }
  return response.status === 204 ? null : response.json();
}